import { create } from 'zustand'

export const useAuthStore = create((set, get) => ({
  user:    null,
  token:   null,
  loading: true,

  login: async (email, password) => {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    })
    if (!res.ok) throw new Error('Credenciales inválidas')
    const data = await res.json()
    set({ user: data.user, token: data.access_token, loading: false })
    return data.user
  },

  refresh: async () => {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 5000)
    try {
      const res = await fetch('/api/auth/refresh', {
        method: 'POST', credentials: 'include',
        signal: controller.signal,
      })
      clearTimeout(timeout)
      if (!res.ok) { set({ user: null, token: null, loading: false }); return }
      const data = await res.json()
      set({ user: data.user, token: data.access_token, loading: false })
    } catch {
      clearTimeout(timeout)
      set({ user: null, token: null, loading: false })
    }
  },

  logout: async () => {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
    set({ user: null, token: null, loading: false })
  },

  getToken: () => get().token,
}))
